import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";
import { IMAGES } from "../lib/constants";

export const EnvCard = ({ env, info, size = "md", onSelect, selected, testId }) => {
  const { t } = useTranslation();
  const closed = info && !info.creation_enabled;
  const h = size === "lg" ? "h-[440px] lg:h-[560px]" : size === "sm" ? "h-[220px]" : "h-[260px] lg:h-[270px]";
  const inner = (
    <>
      <img src={IMAGES[env]} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-[rgba(20,16,12,0.85)] via-[rgba(20,16,12,0.25)] to-transparent" />
      <div className="relative h-full flex flex-col justify-end p-6 sm:p-8 text-[var(--cream)] text-start">
        <p className="eyebrow !text-[var(--gold-soft)] mb-2">{t(`env.${env}.short`)}</p>
        <h3 className="font-heading text-2xl sm:text-3xl">{t(`env.${env}.name`)}</h3>
        {size === "lg" && <p className="mt-3 max-w-md text-[var(--sand)]/85 leading-relaxed">{t(`env.${env}.description`)}</p>}
        {closed && <p className="mt-2 text-xs text-[var(--gold-soft)]">{t("env.closed")}</p>}
        {!onSelect && (
          <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold">
            {t("env.enter")} <ArrowUpRight size={16} className="flip-rtl" />
          </span>
        )}
      </div>
      {selected && <span className="absolute top-4 end-4 rounded-full bg-[var(--gold)] text-[var(--dusk)] text-xs font-bold px-3 py-1">{t("wizard.selected")}</span>}
    </>
  );
  const cls = `env-card relative block overflow-hidden rounded-[28px] ${h} ${selected ? "ring-4 ring-[var(--gold)] ring-offset-4 ring-offset-[hsl(var(--background))]" : ""}`;
  if (onSelect)
    return (
      <button type="button" className={`${cls} w-full disabled:opacity-60`} onClick={() => onSelect(env)} disabled={closed} aria-pressed={selected} data-testid={testId}>
        {inner}
      </button>
    );
  return (
    <Link to={`/explore/${env}`} className={cls} data-testid={testId}>
      {inner}
    </Link>
  );
};
